export const root = {
  background: '{form.field.background}',
  disabledBackground: '{form.field.disabled.background}',
  filledBackground: '{form.field.filled.background}',
  filledHoverBackground: '{form.field.filled.hover.background}',
  filledFocusBackground: '{form.field.filled.focus.background}',
  borderColor: 'transparent',
  hoverBorderColor: 'var(--primary-blue-100)',
  focusBorderColor: 'var(--primary-blue-100)',
  invalidBorderColor: 'var(--red-100)',
  color: 'var(--primary-blue-100)',
  disabledColor: 'var(--primary-blue-60)',
  placeholderColor: 'var(--primary-blue-60)',
  invalidPlaceholderColor: 'var(--primary-blue-60)',
  shadow: 'none',
  paddingX: '{form.field.padding.x}',
  paddingY: '{form.field.padding.y}',
  borderRadius: '{form.field.border.radius}',
  focusRing: {
    width: '{form.field.focus.ring.width}',
    style: '{form.field.focus.ring.style}',
    color: '{form.field.focus.ring.color}',
    offset: '{form.field.focus.ring.offset}',
    shadow: '0px 0px 0px 3px var(--active-60)'
  },
  transitionDuration: '{form.field.transition.duration}',
  sm: {
    fontSize: '{form.field.sm.font.size}',
    paddingX: '{form.field.sm.padding.x}',
    paddingY: '{form.field.sm.padding.y}'
  },
  lg: {
    fontSize: '{form.field.lg.font.size}',
    paddingX: '{form.field.lg.padding.x}',
    paddingY: '{form.field.lg.padding.y}'
  }
};

export default {
  root
}